<div>
  <app-templates-filter
    [templateCategories]="templateCategories"
    (search)="searchTemplates($event)">
  </app-templates-filter>
  <mat-divider></mat-divider>
  <app-templates-table *ngIf="templates"
    [templates]="templates.content"
    [pageSize]="templates.size"
    [totalElements]="templates.totalElements"
    (loadTemplates)="loadTemplates($event)"
    (updateTemplateStatus)="updateTemplateStatus($event)"
    (deleteTemplate)="deleteTemplate($event)">
  </app-templates-table>
</div>
